// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33K3C","name":"styles_name__2Rc6K","phone":"styles_phone__37yH2"};